import React from 'react'
import Link from 'gatsby-link'
import SbEditable from 'storyblok-react'

import styles from './styles.module.scss'

const LogoItem = (props) => {
	return (
		<SbEditable content={props.blok}>
			<li className={styles['logo-item']}>
                <a className={styles['logo-item__link']} href={props.blok.link.url} target='_blank'>
                    <img className={styles['logo-item__logo']} src={props.blok.logo.filename} alt='' />
                </a>
            </li>
		</SbEditable>
	)
}

export default LogoItem
